import createReducer from '../../../data/shared/createReducer';
import {
    REQUEST_USER_SESSION,
    RECEIVE_IDENTIFIED_USER,
    RECEIVE_UNIDENTIFIED_USER,
    UPDATE_ACCOUNT_FAILURE,
    UPDATE_ACCOUNT_SUCCESS, UPDATE_ACCOUNT_REQUEST, REMOVE_ACCOUNT_IMAGE
} from '../constants/action_types';
import { book } from '../../../data/booking/constants/action_types';

const initialState = {
    isFetching: false,
    data: null,
    update: {
        isFetching: false,
        result: null
    }
};

const requestUserSession = (state, action) => ({
    ...state,
    isFetching: true,
    data: null
});

const receiveIdentifiedUser = (state, action) => ({
    ...state,
    isFetching: false,
    data: action.data
});

const updateAccountSuccess = (state, action) => ({
    ...state,
    update: {
        isFetching: false,
        result: 'success'
    },
    data: action.data
});

const updateAccountFailure = (state, action) => ({
    ...state,
    update: {
        isFetching: false,
        result: 'error'
    }
});

const updateAccountRequest = (state, action) => ({
    ...state,
    update: {
        isFetching: true,
        result: null
    }
});

const receiveUnidentifiedUser = (state, action) => ({
    ...state,
    isFetching: false,
    data: null
});

const removeImage = (state, action)=>{
    console.log("ca marche TT");
   return{ ...state,
   data : {
    ...state.data,
    image : ""
   }
    
};
}

const userSessionReducer = createReducer(initialState, {
    [REQUEST_USER_SESSION]: requestUserSession,
    [RECEIVE_IDENTIFIED_USER]: receiveIdentifiedUser,
    [book.RECEIVE_USER_SESSION]: receiveIdentifiedUser,
    [RECEIVE_UNIDENTIFIED_USER]: receiveUnidentifiedUser,
    [UPDATE_ACCOUNT_REQUEST]: updateAccountRequest,
    [UPDATE_ACCOUNT_SUCCESS]: updateAccountSuccess,
    [UPDATE_ACCOUNT_FAILURE]: updateAccountFailure,
    [REMOVE_ACCOUNT_IMAGE] : removeImage
});

export default userSessionReducer;
